import { Box } from '@mui/material';

import TimesheetRow from './TimesheetRow';
import { CustomCsvDownloader } from './CustomToolbarComponents';

import type { Responsive, SelectableRows } from 'mui-datatables';

export const timesheetTableOptions = (isReadOnlyView: boolean) => ({
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  fixedHeader: false,
  sort: true,
  download: false,
  responsive: 'standard' satisfies Responsive,
  selectableRows: 'none' satisfies SelectableRows,
  textLabels: {
    body: {
      noMatch: 'Attention: There are currently no entries for this time period',
    },
  },
  customToolbar: (tableData: any) => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {isReadOnlyView && <CustomCsvDownloader data={tableData} />}
      </Box>
    );
  },
  customRowRender: (data: any[]) => {
    const [
      id,
      provider_name,
      client_name,
      service_code,
      _date,
      date_start,
      date_end,
      _duration,
      label,
      client_id,
      service_code_id,
      utc_offset,
      read_only,
      pay_period,
    ] = data;

    const timesheet = {
      id,
      provider_name,
      client_name,
      service_code,
      date_start,
      date_end,
      label,
      client_id,
      service_code_id,
      utc_offset,
      read_only,
      pay_period,
    };
    return <TimesheetRow key={id} timesheet={timesheet} />;
  },
});
